/* * @Author: Wei Guojun * @Date: 2021-04-22 15:35:16 * @Last Modified by: Wei
Guojun * @Last Modified time: 2021-12-30 14:59:52 */
<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div class="model sender">
        <el-row class="_header">
          <el-col class="left" :span="10">
            <img src="@/assets/images/icon_ji.png" alt />寄件人信息
          </el-col>
          <el-col class="right" :span="12">
            <el-checkbox
              v-model="ruleForm.send.save_info"
              label="保存到我的寄件人"
              name="type"
            ></el-checkbox>
          </el-col>
        </el-row>
        <div class="from">
          <el-row>
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div>姓名</div>
                  </el-col>
                  <el-col class="input" :span="20">
                    <el-form-item style="margin-left: 0" prop="send.name">
                      <el-input
                        placeholder="请输入姓名"
                        suffix-icon="el-icon-user"
                        v-model="ruleForm.send.name"
                        clearable
                      ></el-input>
                      <span class="span">*</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="3">
                    <div>联系方式</div>
                  </el-col>
                  <el-col class="input" :span="21">
                    <div>
                      <el-form-item prop="send.phone">
                        <el-input
                          type="text"
                          placeholder="请输入联系手机或电话"
                          v-model.trim="ruleForm.send.phone"
                          suffix-icon="el-icon-phone-outline"
                          clearable
                        ></el-input>
                        <span class="span">*</span>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 15px">
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div>省/市/区</div>
                  </el-col>
                  <el-col class="input" :span="20">
                    <div>
                      <el-form-item prop="send.pca">
                        <el-cascader
                          @change="changeAddress('send')"
                          ref="send"
                          :options="sender_address"
                          v-model="ruleForm.send.pca"
                          placeholder="请选择省/市/区"
                          filterable
                        ></el-cascader>
                        <span class="span">*</span>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="3">
                    <div>详细地址</div>
                  </el-col>
                  <el-col class="input" :span="21">
                    <div>
                      <el-form-item prop="send.address">
                        <el-input
                          type="text"
                          placeholder="请输入详细地址"
                          suffix-icon="el-icon-map-location"
                          v-model.trim="ruleForm.send.address"
                          clearable
                        ></el-input>
                        <span class="span">*</span>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="model addressee">
        <el-row class="_header">
          <el-col class="left" :span="10">
            <img src="@/assets/images/icon_show.png" alt />收件人信息
          </el-col>
          <el-col class="right" :span="12">
            <el-checkbox
              v-model="ruleForm.collect.save_info"
              label="保存到我的收件人"
              name="type"
            ></el-checkbox>
          </el-col>
        </el-row>
        <div class="from">
          <el-row>
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div>收件人姓名</div>
                  </el-col>
                  <el-col class="input" :span="20">
                    <div>
                      <el-form-item prop="collect.name">
                        <el-input
                          placeholder="请输入姓名"
                          suffix-icon="el-icon-user"
                          v-model="ruleForm.collect.name"
                          clearable
                          :fetch-suggestions="querySearch"
                          :trigger-on-focus="false"
                          @select="handleSelect"
                        ></el-input>
                        <span class="span">*</span>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="3">
                    <div>联系方式</div>
                  </el-col>
                  <el-col class="input" :span="21">
                    <div>
                      <el-form-item prop="collect.phone">
                        <el-input
                          type="text"
                          placeholder="请输入联系手机或电话"
                          v-model.trim="ruleForm.collect.phone"
                          suffix-icon="el-icon-phone-outline"
                          clearable
                        ></el-input>
                        <span class="span">*</span>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 15px">
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div>省/市/区</div>
                  </el-col>
                  <el-col class="input" :span="20">
                    <div>
                      <el-form-item prop="collect.pca">
                        <el-cascader
                          @change="changeAddress('collect')"
                          ref="collect"
                          :options="sender_address"
                          v-model="ruleForm.collect.pca"
                          placeholder="请选择省/市/区"
                          filterable
                        ></el-cascader>
                        <span class="span">*</span>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="3">
                    <div>详细地址</div>
                  </el-col>
                  <el-col class="input" :span="21">
                    <div>
                      <el-form-item prop="collect.address">
                        <el-input
                          type="text"
                          placeholder="请输入详细地址"
                          suffix-icon="el-icon-map-location"
                          v-model.trim="ruleForm.collect.address"
                          clearable
                        ></el-input>
                        <span class="span">*</span>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="model other">
        <div class="from">
          <el-row>
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div>物品类型</div>
                  </el-col>
                  <el-col class="input" :span="20">
                    <div>
                      <el-form-item>
                        <el-select
                          v-model="typeContent"
                          placeholder="请选择物品类型"
                        >
                          <el-option
                            v-for="item in typeArr"
                            :key="item.typeArr"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <span class="span">*</span>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div style="padding-top:20px">
                <el-row>
                  <el-col class="title" :span="4">
                    <div>快递类型</div>
                  </el-col>
                  <el-col class="input" :span="20">
                    <div>
                      <el-form-item>
                        <el-select
                          v-model="express_type"
                          placeholder="快递类型"
                        >
                          <el-option
                            v-for="item in expressArr"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <span class="span">*</span>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="weight">
                <div class="left">
                  <div style="color:#222222">物品重量</div>
                  <div style="font-size: 12px;color:#999999">实际重量以快递员揽件核实为准</div>        
                </div>
                <div class="right">
                  <el-form-item prop="goods_weight">
                    <el-input-number v-model="ruleForm.goods_weight" @input.native="handleWeight()" ref="goodWeight"
                    :precision="2" :step="1" :max="99.90" :min="0" size="small"></el-input-number> KG
                  </el-form-item>
                </div>
              </div>
              <div>
                <el-row>
                  <el-col class="title" :span="3">
                    <div>包裹备注</div>
                  </el-col>
                  <el-col class="input" :span="21">
                    <div>
                      <el-form-item>
                        <el-input
                          type="textarea"
                          :rows="1"
                          placeholder="选填项,注意由快递员打印的包裹备注只可打出20字"
                          maxlength="60"
                          height="100%"
                          show-word-limit
                          v-model.trim="textarea"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>
    <div class="btnList">
      <el-button plain @click="$parent.$parent.dialog = false">取消</el-button>
      <el-button type="primary" style="margin-left: 40px" @click="save"
        >保存到正常信息订单</el-button
      >
    </div>
  </div>
</template>
<script>
import util from "@/util/util";
import home from "@/api/home";
export default {
  name: "editSheet",
  props: ["itemData"],

  data() {
    var checkPhone = (rule, value, callback) => {
      const telReg = /^(400|800)(-)?[016789]\d{2}(-)?\d{4}$/g;
      const ghReg = /^\d{3,4}(-)?\d{7,8}$/g;
      const phoneReg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/g;
      if (!value) {
        return callback(new Error("电话号码不能为空"));
      }
      setTimeout(() => {
        if ((value.length>=11&&value.length<=16) || telReg.test(value) || phoneReg.test(value) || ghReg.test(value)) {
          callback();
        } else {
          callback(new Error("电话号码格式不正确"));
        }
      }, 100);
    };
    var checkWeight = (rule, value, callback) => {
        if (value <= 0) {
          callback(new Error('请输入物品重量'));
        } else {
          callback();
        }
     };
    return {
      typeArr: [
        { label: "文件", value: 0 },
        { label: "电子产品", value: 1 },
        { label: "办公/鞋服箱包", value: 2 },
        { label: "美妆日化", value: 3 },
        { label: "珠宝饰品", value: 4 },
        { label: "食品/保健/药品", value: 5 },
        { label: "工艺品", value: 6 },
        { label: "玩具乐器", value: 7 },
        { label: "其他", value: 8 },
      ],
      expressArr:[
        { label: "普通快递", value: "PK" },
        { label: "智橙网", value: "TK" },
      ],
      sender_address: [], // 寄件人地区选项配置
      typeContent: "服饰", //物品类型
      textarea: "", //备注说明
      id: "", //要编辑的id
      express_type:'',
      ruleForm: {
        send: {
          save_info: false, // 是否保存信息
          analysis: "", // 解析数据
          isAnalysis: false,
          name: "", // 姓名
          phone: "", // 手机号
          province: "", // 省
          province_code: "", //省编码
          city: "", // 市
          city_code: "", //市编码
          city_list: [], // 市列表数据
          area: "", //区
          area_code: "", //区编码
          area_list: [], //区列表
          address: "", // 详细地址
          pca: [], // 省市区
        },
        collect: {
          save_info: false, // 是否保存信息
          analysis: "", // 解析数据
          isAnalysis: false,
          name: "", // 姓名
          phone: "", // 手机号
          province: "", // 省
          province_code: "", //省编码
          city: "", // 市
          city_code: "", //市编码
          city_list: [], // 市列表
          area: "",
          area_code: "", //区编码
          area_list: [], //区列表
          address: "", // 详细地址
          pca: [], // 省市区
          type: "", //类型
        },
        goods_weight:0,  // 物品重量
      },
      rules: {
        "send.name": [
          {
            required: true,
            message: "请填写寄件人姓名",
            trigger: "blur",
          },
          {
            min: 1,
            max: 10,
            message: "姓名长度在 1到 10个字符",
            trigger: "blur",
          },
        ],
        "send.phone": [
          {
            validator: checkPhone,
            trigger: "blur",
          },
        ],
        "send.pca": [
          {
            required: true,
            message: "请选择省市区",
            trigger: "change",
          },
        ],
        "send.address": [
          {
            required: true,
            message: "请填写详细地址",
            trigger: "blur",
          },
          {
            min: 3,
            max: 75,
            message: "请填写详细地址，3-75个字之间",
            trigger: "blur",
          },
        ],
        "send.province": [
          {
            required: true,
            message: "省不能为空",
            trigger: "change",
          },
        ],
        "send.city": [
          {
            required: true,
            message: "市不能为空",
            trigger: "change",
          },
        ],
        "send.area": [
          {
            required: true,
            message: "区不能为空",
            trigger: "change",
          },
        ],
        "collect.name": [
          {
            required: true,
            message: "请填写收件人姓名",
            trigger: "blur",
          },
          {
            min: 1,
            max: 10,
            message: "姓名长度在 1到 10个字符",
            trigger: "blur",
          },
        ],
        "collect.phone": [
          {
            validator: checkPhone,
            trigger: "blur",
          },
        ],
        "collect.pca": [
          {
            required: true,
            message: "请选择省市区",
            trigger: "change",
          },
        ],
        "collect.province": [
          {
            required: true,
            message: "省不能为空",
            trigger: "change",
          },
        ],
        "collect.province_code": [
          {
            required: true,
            message: "省不能为空",
            trigger: "change",
          },
        ],
        "collect.city": [
          {
            required: true,
            message: "市不能为空",
            trigger: "change",
          },
        ],
        "collect.city_code": [
          {
            required: true,
            message: "市不能为空",
            trigger: "change",
          },
        ],
        "collect.area": [
          {
            required: true,
            message: "区不能为空",
            trigger: "change",
          },
        ],
        "collect.area_code": [
          {
            required: true,
            message: "区不能为空",
            trigger: "change",
          },
        ],
        "collect.address": [
          {
            required: true,
            message: "请填写详细地址",
            trigger: "blur",
          },
          {
            min: 3,
            max: 75,
            message: "详细地址需在3-75个字之间",
            trigger: "blur",
          },
        ],
        'goods_weight': [
          {
            validator: checkWeight,
            trigger: "change",
          },
        ],
      },
      dialog: false,
      restaurants: [],
    };
  },
  created() {
    this.sender_address = this.ysbAddressFile.getcity()
  },
  mounted() {
    let send = {
      name: this.itemData.sender_name,
      phone: this.itemData.sender_phone,
      province: this.itemData.sender_province,
      province_code: this.itemData.sender_province_code || "",
      city: this.itemData.sender_city,
      city_code: this.itemData.sender_city_code || "",
      area: this.itemData.sender_district,
      area_code: this.itemData.sender_district_code || "",
      address: this.itemData.sender_address,
      pca: [
        this.itemData.sender_province_code,
        this.itemData.sender_city_code,
        this.itemData.sender_district_code,
      ],
    };
    if (send.pca.some((el) => el == "")) {
      send.pca = "";
    }
    this.ruleForm.send = Object.assign(this.ruleForm.send, send);
    let collect = {
      name: this.itemData.receiver_name,
      phone: this.itemData.receiver_phone,
      province: this.itemData.receiver_province,
      province_code: this.itemData.receiver_province_code || "",
      city: this.itemData.receiver_city,
      city_code: this.itemData.receiver_city_code || "",
      area: this.itemData.receiver_district,
      area_code: this.itemData.receiver_district_code || "",
      address: this.itemData.receiver_address,
      pca: [
        this.itemData.receiver_province_code,
        this.itemData.receiver_city_code,
        this.itemData.receiver_district_code,
      ],
    };
    if (collect.pca.some((el) => el == "")) {
      collect.pca = "";
    }
    this.ruleForm.collect = Object.assign(this.ruleForm.collect, collect);
    this.textarea = this.itemData.item_note;
    this.typeContent = this.itemData.item_type;
    this.ruleForm.goods_weight = this.isNumericString(this.itemData.goods_weight) ? this.itemData.goods_weight : 0.00
    console.log(this.ruleForm, this.itemData)
    this.express_type = this.itemData.express_type,
    this.id = this.itemData.id;
  },
  methods: {
    isNumericString(str) {
       return Number.isFinite(+str);
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleWeight(val){
      this.ruleForm.goods_weight = this.$refs.goodWeight.displayValue
      this.$refs.ruleForm.validateField('goods_weight')
    },
    handleSelect(item) {
      console.log(item);
    },
    //保存
    save() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const send = this.ruleForm.send;
          const collect = this.ruleForm.collect;
          let query = {
            account_id: util.getCookie("account_id"),
            id: this.id,
            id_result: true,
            item_note: this.textarea,
            item_note_result: true,
            item_type: this.typeContent,
            express_type:this.express_type,
            item_type_result: true,
            goods_weight:this.ruleForm.goods_weight.toFixed(2),
            goods_weight_result:true,            
            receiver_address: collect.address,
            receiver_address_result: true,
            receiver_city: collect.city,
            receiver_city_code: collect.city_code,
            receiver_district: collect.area,
            receiver_district_code: collect.area_code,
            receiver_name: collect.name,
            receiver_name_result: true,
            receiver_phone: collect.phone,
            receiver_phone_result: true,
            receiver_province: collect.province,
            receiver_province_code: collect.province_code,
            sender_address: send.address,
            sender_address_result: true,
            sender_city: send.city,
            sender_city_code: send.city_code,
            sender_district: send.area,
            sender_district_code: send.area_code,
            sender_name: send.name,
            sender_name_result: true,
            sender_phone: send.phone,
            sender_phone_result: true,
            sender_province: send.province,
            sender_province_code: send.province_code,
          };
          let words = [{'index':0,'origin_words':util.trimAll(query.item_note)},{'index':1,'origin_words':util.trimAll(query.sender_address)},{'index':2,'origin_words':util.trimAll(query.receiver_address)}]
          home.sensitivewords(this,words).then(res=>{
            if(res.success){
              const resultArr = res.data;
              let filwordsArr = resultArr.filter(el=> el.hit_sensitive == 1)
              if(filwordsArr.length){
                this.textarea = resultArr[0].sensitive_words;
                query.item_note = this.textarea;
                this.ruleForm.send.address = resultArr[1].sensitive_words;
                query.sender_address = this.ruleForm.send.address;
                this.ruleForm.collect.address = resultArr[2].sensitive_words;
                query.receiver_address = this.ruleForm.collect.address;
                this.$confirm("您输入的信息中含有敏感词请修改后重新操作点击忽略订单中将以“□”代替", '提示', {
                  confirmButtonText: '忽略',
                  cancelButtonText: '去修改',
                  type: 'warning'
                }).then(() => {
                  this.save_next(query);
                }).catch(() => {         
                });
              }else{
                this.save_next(query);
              }
            } 
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    save_next(query){
      home.updateParcel(this, query).then((res) => {
        if (res.success) {
          this.$message.success("已保存到正常信息订单！");
          if(this.$store.state.mgcColorRow.includes(query.id)){
            this.$store.state.mgcColorRow.split(this.$store.state.mgcColorRow(query.id),1)
          }
          this.$parent.$parent.loadData();
          this.$parent.$parent.dialog = false;
          if (this.ruleForm.send.save_info) {
            home.CreateAddress(this, "send", "S");
          }
          if (this.ruleForm.collect.save_info) {
            home.CreateAddress(this, "collect", "R", this.collect);
          }
        }
      });
    },
    /** 地址解析 */
    doAnalysis(analysis, type) {
      let self = this;
      if (!self.ruleForm[type].analysis) {
        self.$message({
          type: "warning",
          message: "请填写解析内容",
        });
        return;
      }
      // self.$showLoading();
      self.ruleForm[type].isAnalysis = true;
      home.doAnalysis(self, analysis).then((res) => {
        self.ruleForm[type].isAnalysis = false;
        if (res.success) {
          this.changeTrigger("change");
          let data = res.data;
          self.ruleForm[type].pca = [
            data.province_code,
            data.city_code,
            data.district_code,
          ];
          self.ruleForm[type].name = data.name;
          self.ruleForm[type].phone = data.telephone;
          self.ruleForm[type].province = data.province_name;
          self.ruleForm[type].city = data.city_name;
          self.ruleForm[type].area = data.district_name;
          self.ruleForm[type].province_code = data.province_code;
          self.ruleForm[type].city_code = data.city_code;
          self.ruleForm[type].area_code = data.district_code;
          self.ruleForm[type].address = data.address;

          if (type == "send") {
            this.validateFields(this.fieldSend, "");
          } else {
            this.validateFields(this.fieldCollect, "");
          }
        } else {
        }
      });
    },
    /** 解析绑定地址 */
    changeAddress(type) {
      if (!type) return;
      let address = this.$refs[type].getCheckedNodes()[0].pathLabels; // 地址显示
      let code = this.$refs[type].getCheckedNodes()[0].path; // 地区编码
      this.ruleForm[type].province = address[0];
      this.ruleForm[type].province_code = code[0];
      this.ruleForm[type].city = address[1];
      this.ruleForm[type].city_code = code[1];
      this.ruleForm[type].area = address[2];
      this.ruleForm[type].area_code = code[2];
    },
  },
};
</script>
<style lang="stylus" scoped>
// .home {
  .model {
    background: #fff;
    border-radius: 4px;

    ._header {
      height: 50px;
      padding: 0 40px;
      border-bottom: 1px solid #E8E8E8;

      .left {
        float: left;
        line-height: 50px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(33, 33, 33, 1);
        display: flex;
        align-items: center;

        img {
          width: 20px;
          height: 28px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }

      .right {
        line-height: 65px;
        font-weight: 400;
        color: rgba(28, 139, 246, 1);
        display: flex;
        align-items: center;
        justify-content: flex-end;

        a {
          font-size: 14px;
          color: #1C8BF6;
        }

        img {
          width: 10px;
          height: 10px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }

    .from {
      padding: 15px 40px 0px 40px;

      >.el-row {
        margin-bottom: 20px;
      }

      .el-row {
        display: flex;
        align-items: center;
        font-size: 14px;

        .title {
          text-align: right;
          margin-right: 10px;
          color: #212121;
        }

        .input {
          /deep/ .el-form-item {
            margin-bottom: 0;

            .el-input {
              width: 97%;
              float: left;
            }

            /deep/ .el-form-item__content {
              margin: 0 !important;
            }
          }

          .el-cascader {
            width: 97%;
            float: left;

            // margin-right:10px;
            /deep/.el-input {
              width: 100% !important;
            }
          }

          .el-select {
            width: 97%;
            float: left;

            /deep/.el-input {
              width: 100% !important;
            }
          }

          .span {
            color: #FF0000;
            font-size: 14px;
            float: right;
          }
        }
      }

      .parse {
        background: #1C8BF6;
        color: #fff;
        border-radius: 0 4px 4px 0;
      }
    }
  }

  .addressee {
    margin-top: 0px;

    .collect-list {
      height: 40px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      background: rgba(28, 139, 246, 0.1);
      border-radius: 4px;
      color: #212121;
      justify-content: space-between;

      .left {
        flex: 1;
        display: flex;
        align-items: center;

        .rod {
          display: inline-block;
          width: 15px;
          height: 15px;
          border: 1px solid #333;
          border-radius: 100%;
          font-size: 12px;
          line-height: 17px;
          text-align: center;
          margin-right: 10px;
        }
      }

      .right {
        flex-basis: 60px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        img {
          width: 20px;
          height: 20px;
          cursor: pointer;
          margin-left: 15px;
        }
      }
    }
  }

  .other {
    .el-select {
      width: 100%;
    }

    .from {
      padding-top: 0;
    }

    .from > .el-row {
      margin-bottom: 0px;
    }

    .from .el-row {
      align-items: flex-start;

      .title {
        margin-top: 5px;
      }
    }

    .el-textarea {
      height: 100px;

      /deep/ .el-textarea__inner {
        height: 100%;
      }
    }
  }

  footer {
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    line-height: 60px;
    text-align: center;
    box-shadow: 1px 0 7px rgba(0, 0, 0, 0.1);
    .footBtn{
      width 150px
      margin-right 50px
    }
  }

  /deep/.el-textarea textarea {
    resize: none;
  }

  .home .other .el-textarea .el-textarea__inner {
    resize: none;
  }

  /deep/.el-textarea .el-input__count {
    line-height: 20px;
  }

  /deep/.el-form-item__content {
    margin-left: 0 !important;
  }
// }
  .btnList{
      text-align center
      padding-top:20px
      /deep/ .el-button {
          width 180px
      }
  }
  .weight{
    display: flex;
    justify-content: flex-start;
  }
  .weight .left{
    padding-left: 14px;
  }
  .weight .right{
    margin-left:20px
  }
</style>
